import {
    Box,
    Grid,
    IconButton,
    Tooltip,
    Typography,
    Dialog,
    DialogTitle,
    CircularProgress,
    Button,
    Stack
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import NoteStickyIndividual from './individualStickynote';
import { Close } from '@material-ui/icons';
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup';
import { useSnackbar } from 'notistack';
import ArchivedStickyNotes from './ArchivedStickyNotes';
import { getStickySeenMap, isStickyNoteNew } from './stickyNoteSeenUtils';

export default function StickyNotesBoard({ 
  fetchNotesL, 
  onCloseDialog,
  // 🚀 LOADING STATE: Loading state props from parent
  setIsLoading,
  isLoading,
  startSaving,
  finishSaving,
}) {
    const [notes, setNotes] = useState([]);
    const [openStickyDialog, setOpenStickyDialog] = useState(false);
    const [isAdd,setIsAdd] = useState(false);
    const userSession = JSON.parse(localStorage.getItem('user'));
    const [loading, setLoading] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [selectedId, setSelectedId] = useState('');
    const [showArchived, setShowArchived] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [refreshArchivedTrigger, setRefreshArchivedTrigger] = useState(false);
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [noteUnsavedChanges, setNoteUnsavedChanges] = useState({});
    
    console.log('selectedId++++++++++++', selectedId, openDelete)

    const setNoteUnsavedChange = (noteId, hasChanges) => {
        setNoteUnsavedChanges(prev => ({
            ...prev,
            [noteId]: hasChanges
        }));
    };

    const hasAnyUnsavedChanges = () => {
        return Object.values(noteUnsavedChanges).some(hasChanges => hasChanges) || unsavedChanges;
    };
    const deleteNote = async () => {
        try {
            await axios.post(`${REST_API_END_POINT}tickets/delete-sticky-note-individual`, {
                id: selectedId,
                deleted_by: userSession?.user_id
            });
            enqueueSnackbar('Sticky Note deleted successfully', { variant: 'success' });
            setSelectedId('')
            setOpenDelete(false)
            fetchNotes()
            fetchNotesL()
        } catch (error) {
            console.error('Delete error:', error);
            enqueueSnackbar('Failed to delete Sticky Note', { variant: 'error' });
        }
    }
    const fetchNotes = async (save) => {
        try {
            if (!save) {
                setLoading(true)
            }
            const res = await axios.post(
                `${REST_API_END_POINT}tickets/get-all-sticky-notes-individual`,
                { userId: userSession?.user_id }
            );

            if (res.data?.status === 1 && Array.isArray(res.data.data)) {
                setNotes(res.data.data);
            } else if (res.data?.status === 1 && res.data.data) {
                setNotes([res.data.data]);
            } else {
                setNotes([]);
            }
        } catch (err) {
            console.error("Failed to fetch sticky notes", err);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotes();
    }, [refreshArchivedTrigger]);

    const myNotes = notes.filter((note) => note.added_by === userSession?.user_id);
    const otherNotes = notes.filter((note) => note.added_by !== userSession?.user_id);
    const seenMap = getStickySeenMap(userSession?.user_id);

    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Box>
                    {!showArchived ? (<Tooltip title="Add New Note">
                        <IconButton
                            onClick={() => {
                                setIsAdd(true)
                                setOpenStickyDialog(true)
                            }
                            }
                            color="primary"
                            disabled={showArchived}
                        >
                            <AddIcon />
                        </IconButton>
                    </Tooltip>) : ''}
                    <Tooltip title={showArchived ? 'Show Unarchived Notes' : 'Show Archived Notes'}>
                        <Button
                            color='info'
                            variant='contained'
                            startIcon={<Stack className={showArchived ? 'material-symbols--archive-outline' : 'material-symbols--unarchive-outline'} />}
                            onClick={() => {
                                setShowArchived((prev) => {
                                    if (prev === true) {
                                        // If switching from archived to unarchived, refetch notes
                                        fetchNotes();
                                    }
                                    return !prev;
                                });
                            }}
                            sx={{ ml: 1 }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                {showArchived ? 'Show Unarchived Notes' : 'Show Archived Notes'}
                            </Typography>
                        </Button>
                    </Tooltip>
                </Box>
            </Box>
            {showArchived ? (
                <ArchivedStickyNotes fetchNotesL={fetchNotesL} userSession={userSession} />
            ) : (
                loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {myNotes.length > 0 && (
                            <>
                                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>My Notes</Typography>
                                <Grid container spacing={3}>
                                    {myNotes.map((note) => (
                                        <Grid item xs={12} sm={6} md={6} key={`my-${note.id}`}>
                                            <NoteStickyIndividual
                                                fetchNotesL={fetchNotesL}
                                                note={note}
                                                setSelectedId={setSelectedId}
                                                setOpenDelete={setOpenDelete}
                                                noteId={note.id}
                                                initialColor={note?.color}
                                                initialContent={note.sticky_note}
                                                initialPrivate={note.is_private}
                                                userName={note.user_name}
                                                updated_by_name={note.updated_by_name}
                                                updatedOn={note.updated_on}
                                                addedOn={note.timestamp}
                                                updatedName={note.updated_by_name}
                                                onRefresh={fetchNotes}
                                                setOpenStickyDialog={setOpenStickyDialog}
                                                isReadOnly={false}
                                                isNew={isStickyNoteNew(note, userSession?.user_id, seenMap)}
                                                onRefreshArchived={() => setRefreshArchivedTrigger(prev => !prev)}
                                                unsavedChanges={noteUnsavedChanges[note.id] || false}
                                                setUnsavedChanges={(hasChanges) => setNoteUnsavedChange(note.id, hasChanges)}
                                                onCloseDialog={onCloseDialog}
                                                // 🚀 LOADING STATE: Pass loading state props
                                                setIsLoading={setIsLoading}
                                                isLoading={isLoading}
                                                startSaving={startSaving}
                                                finishSaving={finishSaving}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                        )}
                        {otherNotes.length > 0 && (
                            <>
                                <Typography variant="subtitle2" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>Notes Shared With Me</Typography>
                                <Grid container spacing={3}>
                                    {otherNotes.map((note) => (
                                        <Grid item xs={12} sm={6} md={6} key={`other-${note.id}`}>
                                            <NoteStickyIndividual
                                                fetchNotesL={fetchNotesL}
                                                note={note}
                                                noteId={note.id}
                                                initialContent={note.sticky_note}
                                                initialPrivate={note.is_private}
                                                initialColor={note?.color}
                                                userName={note.user_name}
                                                updatedOn={note.updated_on}
                                                addedOn={note.timestamp}
                                                updatedName={note.updated_by_name}
                                                onRefresh={fetchNotes}
                                                setOpenStickyDialog={setOpenStickyDialog}
                                                isReadOnly={true}
                                                isNew={isStickyNoteNew(note, userSession?.user_id, seenMap)}
                                                unsavedChanges={noteUnsavedChanges[note.id] || false}
                                                setUnsavedChanges={(hasChanges) => setNoteUnsavedChange(note.id, hasChanges)}
                                                onCloseDialog={onCloseDialog}
                                                // 🚀 LOADING STATE: Pass loading state props
                                                setIsLoading={setIsLoading}
                                                isLoading={isLoading}
                                                startSaving={startSaving}
                                                finishSaving={finishSaving}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                        )}
                        {myNotes.length === 0 && otherNotes.length === 0 && (
                            <Box sx={{ mt: 6, textAlign: 'center' }}>
                                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#999' }}>
                                    📝 No sticky notes available
                                </Typography>
                                <Typography variant="subtitle1" sx={{ mt: 1, color: '#aaa' }}>
                                    Click the + button above to create your first note!
                                </Typography>
                            </Box>
                        )}
                    </>
                )
            )}
            <Dialog
                open={openStickyDialog}
                onClose={() => setOpenStickyDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ pl: 2.4, pr: 3, pb: 1.5, pt: 2 }}>
                    Add New Sticky Note
                    <IconButton
                        onClick={() => {
                            setOpenStickyDialog(false)
                            setIsAdd(false)
                            setUnsavedChanges(false)
                            setNoteUnsavedChanges({})
                        }}
                        sx={{ position: 'absolute', right: 12, top: 8, color: '#999' }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>

                <Box sx={{ px: 2, pb: 2 }}>
                    <NoteStickyIndividual
                        fetchNotesL={fetchNotesL}
                        initialContent=""
                        noteId={null}
                        userName="You"
                        newNote={true}
                        initialPrivate={false}
                        setOpenStickyDialog={setOpenStickyDialog}
                        onRefresh={fetchNotes}
                        isAdd={isAdd}
                        setIsAdd={setIsAdd}
                        unsavedChanges={unsavedChanges}
                        setUnsavedChanges={setUnsavedChanges}
                        onCloseDialog={onCloseDialog}
                        // 🚀 LOADING STATE: Pass loading state props
                        setIsLoading={setIsLoading}
                        isLoading={isLoading}
                        startSaving={startSaving}
                        finishSaving={finishSaving}
                    />
                </Box>
            </Dialog>
            <ConfirmationPopup
                open={openDelete}
                handleClick={deleteNote}
                handleClose={() => {
                    setOpenDelete(false)
                }}
                message={`You want to delete this note ?`}
            />
        </Box>
    );
}
